import { PaletteOptions } from "@mui/material/styles";
import { Colors, EventsColors } from "../colors";

export const darkPalette: PaletteOptions = {
  action: {
    active: Colors.WHITE,
    disabled: Colors.DISABLED,
    hover: Colors.GREEN_HOVER,
    disabledBackground: Colors.GRAY_DISABLED_INPUT,
    selected: Colors.PRESENT_BLACK_MUTED,
  },
  salmon: {
    main: Colors.SALMON_PASTEL,
  },
  green: {
    main: Colors.GREEN_MAIN,
    background: Colors.GREEN_BACKGROUND,
    action: Colors.GREEN_ACTION,
    actionDarkMode: Colors.GREEN_ACTION_DARK_MODE,
    hoverDarkMode: Colors.GREEN_HOVER_DARK_MODE,
  },
  red: {
    main: Colors.RED_DANGER,
    light: Colors.RED_DANGER_LIGHT,
  },
  black: Colors.BLACK,
  present: {
    greyBackground: Colors.PRESENT_GREY_BG,
  },
  gray: {
    disabled: Colors.GRAY_DISABLED,
    disabledInput: Colors.GRAY_DISABLED_INPUT,
    medium: Colors.GRAY_MEDIUM,
    light: Colors.GRAY_LIGHT,
    lightShade: Colors.GRAY_LIGHT_SHADE,
    main: Colors.GRAY_LIGHT,
    muted1: Colors.GRAY_MUTED1,
    muted2: Colors.GRAY_MUTED2,
  },
  white: Colors.WHITE,
  dark: {
    main: Colors.BLUE_DARK,
    overlay2: Colors.DARK_OVERLAY2,
  },
  blue: {
    main: Colors.BLUE_PRIMARY,
    lightShade1: Colors.BLUE_LIGHTSHADE1,
    lightShade4: Colors.BLUE_LIGHTSHADE4,
    dark: Colors.BLUE_DARK,
    darkShade1: Colors.BLUE_DARKSHADE1,
    darkShade2: Colors.BLUE_DARKSHADE2,
    disabled: Colors.DISABLED,
  },
  darkModeBlue: {
    main: Colors.BLUE_DARK_MODE,
  },
  primary: {
    main: Colors.BLUE_PRIMARY,
  },
  secondary: {
    main: Colors.BLUE_DARK,
  },
  text: {
    primary: EventsColors.WHITE_TERTIARY,
    secondary: EventsColors.WHITE_TERTIARY,
    tertiary: EventsColors.WHITE_TERTIARY,
  },
  yellow: {
    lightShade1: Colors.YELLOW_LIGHTSHADE_1,
    dark: Colors.YELLOW_DARK,
  },
  status: {
    warning: Colors.WARNING,
    success: Colors.SUCCESS,
    error: Colors.ERROR,
  },
  tour: {
    background: Colors.BLUE_DARKSHADE2,
  },
  textInput: {
    backgroundColor: EventsColors.LIGHT_BLACK,
  },
  polls: {
    selectedAnswer: EventsColors.BLUE_SECONDARY,
    otherAnswer: " #FFFFFF33",
    correctAnswer: EventsColors.SUCCESS_DARK,
    incorrectAnswer: EventsColors.ERROR_DARK,
    timerBar: Colors.BLUE_DARK_MODE,
    background: EventsColors.LIGHT_BLACK,
    border: Colors.BLUE_DARKSHADE3,
    ongoing: Colors.BLUE_DARK_MODE,
    draft: EventsColors.GRAY_TERTIARY,
    closed: EventsColors.ERROR_DARK,
    selectedBorder: EventsColors.BLUE_SECONDARY,
    unselectedAnswer: `${EventsColors.GRAY_PRIMARY}33`,
    hoverAnswer: EventsColors.BLUE_ACCENT2,
    activeBorder: EventsColors.BLUE_ACCENT2,
  },
  background: {
    default: Colors.PRESENTATION_MODE_BACKGROUND,
    primary: EventsColors.BLUE_ACCENT2,
    secondary: "#232944",
    tertiary: EventsColors.BACKGROUND,
    chat: EventsColors.BLUE_SECONDARY,
  },
  border: {
    default: "#ECEFF133",
    primary: EventsColors.BLUE_PRIMARY,
  },
  error: {
    main: Colors.RED_DANGER,
    dark: EventsColors.ERROR_DARK,
    light: EventsColors.ERROR_LIGHT,
  },
  warning: {
    main: EventsColors.WARNING_DARK,
    dark: EventsColors.WARNING_DARK,
    light: EventsColors.WARNING_LIGHT,
  },
  success: {
    main: EventsColors.SUCCESS_DARK,
    dark: EventsColors.SUCCESS_DARK,
    light: EventsColors.SUCCESS_LIGHT,
  },
  boxShadow: {
    default: EventsColors.BOX_SHADOW,
  },
  events: {
    black: EventsColors.BLACK,
    blue: EventsColors.BLUE_ACCENT2,
    bluePrimary: EventsColors.BLUE_PRIMARY,
    blueShade1: EventsColors.BLUE_ACCENT3,
    blueShade2: EventsColors.BLUE_ACCENT4,
    blueSecondary: EventsColors.BLUE_SECONDARY,
    dialogContentBackground: EventsColors.LIGHT_BLACK,
    dialogHeaderBackground: Colors.PRESENTATION_MODE_BACKGROUND,
    grayShade1: EventsColors.GRAY_PRIMARY,
    grayShade2: EventsColors.GRAY_SECONDARY,
    grayTertiary: EventsColors.GRAY_TERTIARY,
    greenAccent1: EventsColors.GREEN_ACCENT1,
    greenAccent2: EventsColors.GREEN_ACCENT2,
    greenAccent3: EventsColors.GREEN_ACCENT3,
    lightBlack: EventsColors.LIGHT_BLACK,
    textPrimary: EventsColors.WHITE_TERTIARY,
    whiteTertiary: EventsColors.WHITE_TERTIARY,
    darkGray: EventsColors.DARK_BLACK,
  },
  icon: {
    primary: EventsColors.WHITE_TERTIARY,
    secondary: EventsColors.WHITE_TERTIARY,
    tertiary: EventsColors.LIGHT_BLACK,
  },
  gif: {
    primary: EventsColors.BLUE_DARK_MODE,
    secondary: EventsColors.BLUE_SECONDARY,
  },
  button: {
    default: EventsColors.BLUE_PRIMARY,
    primaryHover: EventsColors.BLUE_ACCENT3,
    secondaryHover: EventsColors.LIGHT_BLACK,
    tertiaryHover: EventsColors.BLUE_SECONDARY,
    warningHover: EventsColors.ERROR_HOVER,
  },
  tooltip: {
    primary: EventsColors.TOOLTIP_BACKGROUND,
  },
};
